import { render, staticRenderFns } from "./estatisticas.vue?vue&type=template&id=5351e35a&"
import script from "./estatisticas.vue?vue&type=script&lang=js&"
export * from "./estatisticas.vue?vue&type=script&lang=js&"
import style0 from "./estatisticas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports